<template>
    <select :name="name" ref="select" class="form-control" :placeholder="$t('labels.choice_one')">
        <option></option>
    </select>
</template>
<style>
    .select2-container--bootstrap .select2-selection--single .select2-selection__rendered{
        line-height: 2.5;
    }
</style>
<script>

    export default {

        data: function () {
            return {

            }
        },
        props : {

            value   : {},

            delay : {
                type    : Number,
                default : 250,
            },

            allowClear : {
                type    : Boolean,
                default : true,
            },

            name : {
                type    : String,
                default : 'select-choice',
            },

            minimumResultsForSearch : {
                type    : Number,
                default : -1,
            },

            tags : {
                type: Boolean,
                default: false,
            },

            options : {
                type: Array,
                default: [],
            },

            placeholder: {
                type : String,
                required: false,
            }
        },

        mounted(){

            let self = this;
            let $el  = $(self.$refs.select);

            $el.select2({


                placeholder:                self.$refs.select.getAttribute('placeholder'),
                //placeholder: "Select a state",

                selectOnClose:              false,
                tags:                       self.tags,
                allowClear:                 self.allowClear,
                data:                       self.options,
                minimumResultsForSearch:    self.minimumResultsForSearch,
                width:                      '100%',

                escapeMarkup:       function (markup) { return markup; }, // let our custom formatter work
            })

            .on('select2:select', function (e) {

                self.emitSelect( e.params.data, e);
            })
            .on('select2:unselect', function (e) {

                self.emitUnselect( e.params.data, e);

            });

            if(this.value){

                $el.val(this.value).trigger('change');
            }
        },

        methods :{

            emitSelect(data, e){

                this.$emit('on-select', data, e);
            },

            emitUnselect(data, e){

                this.$emit('on-unselect', data, e);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/html/Select2.vue